/**
 * Toast notifications — a brief, self-dismissing message in the corner of
 * the screen. Fully self-contained (appends to `document.body`, times its
 * own removal); not tied to any particular view, so it lives here rather
 * than inside GraphVisualizer (where it originated, back when GraphVisualizer
 * was the app's only view).
 */
export function showToast(message: string, type: 'success' | 'error' | 'info'): void {
  const bgColor = type === 'success'
    ? '#22c55e'
    : type === 'error'
      ? '#ef4444'
      : 'var(--accent)';

  const toast = document.createElement('div');
  toast.style.cssText = `
    position: fixed;
    top: 16px;
    right: 16px;
    padding: 12px 20px;
    background: ${bgColor};
    color: #0d1117;
    font-family: 'Courier New', Consolas, 'Liberation Mono', monospace;
    font-size: 13px;
    font-weight: bold;
    border-radius: 8px;
    z-index: 10001;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  `;
  toast.textContent = message;
  document.body.appendChild(toast);

  // Slide in animation
  toast.style.transform = 'translateX(100%)';
  toast.style.transition = 'transform 0.3s ease-out';
  requestAnimationFrame(() => {
    toast.style.transform = 'translateX(0)';
  });

  // Remove after 3 seconds
  setTimeout(() => {
    toast.style.transform = 'translateX(100%)';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}
